import React from 'react';
import { Link } from 'react-router-dom';
import { history } from '../store/configureStore';

class NotFoundPage extends React.Component {

  render() {

    const domElement = document.getElementById('RR-360_results');
    const raceId = domElement.getAttribute('race-id');
    if (raceId) {
      history.push(`#/race/${raceId}`);
      return null;
    }

    return (
      <div>
        <h4>
          404 Page Not Found
        </h4>
        <Link to="/"> Go back to homepage </Link>
      </div>
    );
  }
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js